import { CompRef } from '@wix/document-services-types';
import { ComponentsPlatformService } from '@wix/editor-platform-manifest-services';
import { getAllowedPropertiesForAction } from '../../constants';
import { StylesDerivedNativeActionNames } from '@wix/editor-platform-host-integration-apis';
import { GlobalDesignActionValidator } from '../../types';
import { checkContextMatch } from './helpers';
import { isAllowedStylePresent } from './actionVisibilityRules';

import { EditorPointer } from '@wix/editor-document-logic-api';

const createDefaultStyleActionValidator =
  (actionName: StylesDerivedNativeActionNames): GlobalDesignActionValidator =>
  (
    componentsAPI: ComponentsPlatformService,
    editorPointers: EditorPointer<CompRef>[],
  ) => {
    const allowedStyles = new Set<string>(
      getAllowedPropertiesForAction(actionName),
    );

    const rootContext = componentsAPI.buildManifestAPI({
      editorPointers,
    });

    return checkContextMatch(rootContext, (context) =>
      isAllowedStylePresent(context, allowedStyles),
    );
  };

export default createDefaultStyleActionValidator;
